export interface MicrositePageInstance {
  instanceKey: string;
  templatePageName: string;
  displayName: string;
  slug: string;
}

export const generateInstanceKey = (templatePageName: string, existingInstances: MicrositePageInstance[]): string => {
  const sameType = existingInstances.filter((i) => i.templatePageName === templatePageName);
  return `${templatePageName}_${sameType.length + 1}`;
};

export const generateUniqueDisplayName = (baseDisplayName: string, existingInstances: MicrositePageInstance[]): string => {
  const existingNames = new Set(existingInstances.map((i) => i.displayName));
  if (!existingNames.has(baseDisplayName)) return baseDisplayName;

  let counter = 2;
  while (existingNames.has(`${baseDisplayName} ${counter}`)) counter++;
  return `${baseDisplayName} ${counter}`;
};

export const generateUniqueSlug = (displayName: string, existingInstances: MicrositePageInstance[]): string => {
  const base =
    displayName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'page';

  const existingSlugs = new Set(existingInstances.map((i) => i.slug));
  if (!existingSlugs.has(base)) return base;

  let counter = 2;
  while (existingSlugs.has(`${base}-${counter}`)) counter++;
  return `${base}-${counter}`;
};

export const parsePartialsFromHtml = (
  html: string,
): { layoutName: string; layoutKey: string; blockPairs: Array<{ name: string; key: string }> } => {
  const layoutMatch = html.match(/\{\{#>\s*([^\s\[}]+)(?:\s*\[([^\]]+)\])?/);
  const layoutName = layoutMatch?.[1] ?? '';
  const layoutKey = layoutMatch?.[2] ?? layoutName;

  const allMatches = [...html.matchAll(/\{\{>\s*([^\s\[}]+)(?:\s*\[([^\]]+)\])?\s*/g)];
  const blockPairs = allMatches
    .filter((match) => match[1] !== '@partial-block')
    .map((match) => ({ name: match[1], key: match[2] ?? match[1] }));

  return { layoutName, layoutKey, blockPairs };
};

export const extractSectionsFromBlockHtml = (blocks: { html: string }[]): { Slug: string; DisplayName: string }[] => {
  const sectionRegex = /<section\s+[^>]*id=["']([^"']+)["'][^>]*data-display-name=["']([^"']+)["'][^>]*>/gi;
  const sections: { Slug: string; DisplayName: string }[] = [];
  blocks.forEach((block) => {
    let match;
    while ((match = sectionRegex.exec(block.html)) !== null) {
      const [, Slug, DisplayName] = match;
      sections.push({ Slug, DisplayName });
    }
  });
  return sections;
};
